/**
 * Platform codes from GET /subscriptions/access/status/ (aligned with backend).
 */
export const DEFAULT_APP_PLATFORM = 'tracktalent'
